import './styles/simonsLayout.css';
import VisitCounter from "./VisitCounter.js";
import NavigateFriends from "./NavigateFriends";
import NavigateSite from "./NavigateSite";
import NavigateSKPortal from "./NavigateSKPortal";
import NavigateLinks from "./NavigateLinks";

export default function SkContentPage() {
    return (<>
        <link rel="icon" href="/images/sk/sphere.ico"/>
        <title>Simon King's Personal Webpage</title>

        <div className="skbackground">
            <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                <tbody>
                <tr>
                    <td className="titlebar" valign="middle">
                        <h1 className="titlebar">Simon's personal vanity page (with some programming stuff)</h1>
                    </td>
                </tr>
                <tr>
                    <td className="ruler" width="100%"></td>
                </tr>
                </tbody>
            </table>
            <NavigateSite/>
            <NavigateSKPortal/>
            <NavigateFriends/>
            <div className="content">
                <div className="mainboxhead">
                    <h2>What's the story here?</h2>
                </div>
                <div className="mainboxbody">
                    <p>Welcome to Simon's personal vanity webpage filled with ramblings and rants about things I do
                        for
                        money, things I love doing, usually no money required and things I am deeply interested in,
                        unfortunately hardly anyone will pay me for these.
                    </p>
                    <p>I have worked in the Information Technology industry in Scotland for a frighteningly long
                        time
                        now and earn a decent living. I currently work for a contracting company and have many
                        different
                        clients. See my LinkedIn reference on the sidebar for details in you are interested.
                    </p>
                    <p>Some of the previous companies I have worked with have been involved in a number of cutting
                        edge
                        developments. I am hoping that over the next few years I will be engaged in some more
                        interesting
                        projects linked to my interests and maybe this will introduce some technical rants and raves
                        which I will write down here and may actually help someone.
                    </p>
                </div>
            </div>
            <div className="content">
                <div className="mainboxhead">
                    <h2>Points to note</h2>
                </div>
                <div className="mainboxbody">
                    <p>The links on the top left navigate around this site.
                        The ones below that go to other places on the Internet where I live and play and the links
                        at
                        the bottom are to sites which I have either an affiliation with or have been involved with.
                        The links on the right change each time you refresh the page and point at websites that I
                        found
                        interesting on a particular subject,
                        {/*you can also find the same links on the <Link to="links">interesting links</Link> page.*/}
                    </p>
                    <p>There are a few bits of programming work "in progress" on this site (mostly in the creative
                        blog)
                        and on the relevant pages there are numerous links to other web sites on
                        similar topics that I have found on my travels.</p>
                </div>
            </div>
            <div className="content">
                <div className="mainboxhead">
                    <h2>Other bits of interest</h2>
                </div>
                <div className="mainboxbody">
                    <p>All of the links except 'Interesting links' in the 'Site Navigation' box always open in a new
                        tab or window, depending how you have your browser set up.
                    </p>
                    <p>
                        This site uses CSS extensively which I have tried to test with as many different browsers
                        and
                        viewport sizes as possible. I still haven't got a good phone version going.
                        If you have problems with the layouts or just want to say what you think of the site or want
                        to
                        comment on anything that you have seen on this site,
                        please email <b>webmaster-at-stronans.com</b> replacing the '-at-' text with the normal @
                        sign.
                    </p>
                    <p>
                        <VisitCounter/>
                    </p>
                </div>
            </div>
            <NavigateLinks/>
        </div>
    </>);
}